'use strict';

/** Hello AYA — partner NYC (mismo funnel que Spacest: email + redirect) */

/** Hub de búsqueda filtrado por operador en US */
const AYA_SHOWCASE_PATH = '/findyourcoliving/aya';

const HELLO_AYA_CDN_HOST = 'search.helloaya.com';
const HELLO_AYA_CDN_PREFIX = 'https://search.helloaya.com/images/upload/';

/** Fallback cuando el CDN de AYA devuelve 404 (metadatos GraphQL desactualizados). */
const HELLO_AYA_IMAGE_FALLBACK =
  'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=800&q=75&fm=webp';

function isHelloAyaCdnImageUrl(rawUrl) {
  try {
    const u = new URL(String(rawUrl || ''));
    return u.hostname === HELLO_AYA_CDN_HOST && u.pathname.includes('/images/upload/');
  } catch {
    return false;
  }
}

function isAyaPartnerSource(source) {
  return String(source || '').toLowerCase() === 'aya';
}

/** Añade UTMs Coolliving si la URL aún no los tiene */
function buildAyaPartnerUrl(rawUrl) {
  const raw = String(rawUrl || '').trim();
  if (!raw) return raw;
  try {
    const u = new URL(raw);
    if (!u.searchParams.has('utm_source')) u.searchParams.set('utm_source', 'coolliving');
    if (!u.searchParams.has('utm_medium')) u.searchParams.set('utm_medium', 'referral');
    if (!u.searchParams.has('utm_campaign')) u.searchParams.set('utm_campaign', 'coliving-search');
    return u.toString();
  } catch {
    return raw;
  }
}

module.exports = {
  AYA_SHOWCASE_PATH,
  HELLO_AYA_CDN_HOST,
  HELLO_AYA_CDN_PREFIX,
  HELLO_AYA_IMAGE_FALLBACK,
  isHelloAyaCdnImageUrl,
  isAyaPartnerSource,
  buildAyaPartnerUrl,
};
